import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDBadge from "../../../components/MDBadge";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "../../../shared/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../shared/Navbars/DashboardNavbar";
import Footer from "../../../shared/Footer";

import newsletterService from "../../../services/newsletterService";
import sectionService from "../../../services/sectionService";

function NewsletterDetails() {
  const { id } = useParams();
  const [newsletter, setNewsletter] = useState(null);
  const [sections, setSections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [newsletterRes, sectionsRes] = await Promise.all([
          newsletterService.getById(id),
          sectionService.getAll()
        ]);
        setNewsletter(newsletterRes.data);
        setSections(sectionsRes.data);
      } catch (error) {
        console.error("Error fetching newsletter details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (isLoading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mt={5} mb={9} textAlign="center">
          <MDTypography variant="h4">Cargando...</MDTypography>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  if (!newsletter) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mt={5} mb={9} textAlign="center">
          <MDTypography variant="h4">Newsletter no encontrado</MDTypography>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  const getStatusColor = (status) => (status === "activo" ? "success" : "secondary");

  const getSectionNames = () => {
    if (!newsletter.sections || newsletter.sections.length === 0) return "Todas las secciones";
    return newsletter.sections
      .map((sId) => {
        const section = sections.find((s) => s._id === sId);
        return section ? section.name : "Sección desconocida";
      })
      .join(", ");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={5} mb={9}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={3}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                  <MDTypography variant="h5" fontWeight="bold">
                    Detalles del Suscriptor
                  </MDTypography>
                  <MDBadge
                    badgeContent={newsletter.status}
                    color={getStatusColor(newsletter.status)}
                    variant="gradient"
                    size="lg"
                  />
                </MDBox>
                <Divider />
                <MDBox mt={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <MDTypography variant="button" color="text" fontWeight="bold">
                        Email:
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <MDTypography variant="button" fontWeight="regular">
                        {newsletter.email}
                      </MDTypography>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <MDTypography variant="button" color="text" fontWeight="bold">
                        Suscrito a:
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <MDTypography variant="button" fontWeight="regular">
                        {getSectionNames()}
                      </MDTypography>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <MDTypography variant="button" color="text" fontWeight="bold">
                        Fecha de suscripción:
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <MDTypography variant="button" fontWeight="regular">
                        {new Date(newsletter.createdAt).toLocaleDateString()} {new Date(newsletter.createdAt).toLocaleTimeString()}
                      </MDTypography>
                    </Grid>
                    
                    <Grid item xs={12} sm={4}>
                      <MDTypography variant="button" color="text" fontWeight="bold">
                        Última actualización:
                      </MDTypography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <MDTypography variant="button" fontWeight="regular">
                        {new Date(newsletter.updatedAt).toLocaleDateString()} {new Date(newsletter.updatedAt).toLocaleTimeString()}
                      </MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default NewsletterDetails;
